<template>
	<Table 
			:columns="columns"
			:data-source="rovers"
			:row-selection="rowSelection"
			:pagination="false"
			:loading="loading"
			size="small"
		>
			<template #bodyCell="{ column, record }">
				<template v-if="column.key === 'tariff_current'">
					{{ record.tariff.title }}
				</template>
				<template v-if="column.key === 'tariff_end_datetime'">
					<DatetimeFormatter v-if="record.tariff.is_active" :value="record.tariff.end_datetime" defaultValue="" />
					<Tag v-else color="red">{{ $t('tariffDisplay.notActive') }}</Tag>
				</template>
			</template>
		</Table>
</template>

<script>
import { Table, Tag } from 'ant-design-vue';

import Consts from '@/api/Consts';

import TranslationUtils from '@/i18n/TranslationUtils';

import DatetimeFormatter from '@/components/common/DatetimeFormatter';

export default {
	components: {
		Table, Tag,
		DatetimeFormatter,
	},
	props: {
		rovers: Array,
		loading: Boolean,
		rowSelection: {
			type: Object,
			required: false,
		},
	},
	setup() {
		const columns = TranslationUtils.addTranslatedField(
			Consts.ROVERS_TABLE_TARIFFS_COLUMNS,
			'key', 'title',
			'rovers.tableColumns',
		);
		return {
			columns,
		};
	},
}
</script>
